// ============================================================
//  app.js — Punto de entrada de la aplicación
// ============================================================

import { inicializarAplicacion } from './src/app/init.js';
import { initPerfilDxccWidget } from './src/perfil-dxcc-widget.js';
import './src/shack/shackGuia.js';

document.addEventListener('DOMContentLoaded', () => {
    inicializarAplicacion();
    initPerfilDxccWidget();
});